// extracted by mini-css-extract-plugin
module.exports = {"form":"_124vR","sendIcon":"_377yU","active":"_1HEeR"};